import React from 'react';
import api from '../utils/axiosInstance';

const ActiveSpecialPackageCard = ({ activePurchase, setActivePurchase }) => {
    // Safety check
    if (!activePurchase || !activePurchase.specialPackageId) return null;

    // The package details (Name, duration, code) are embedded inside the purchase record
    const pkg = activePurchase.specialPackageId;

    const handleCancelAutopay = async () => {
        const confirmed = window.confirm(`Are you sure you want to cancel autopay?\nYou won't be charged again.`);
        if (!confirmed) return;

        try {
            const storedUser = JSON.parse(localStorage.getItem('carrierUser') || '{}');
            const res = await api.post('/special-package/cancel-subscription', {
                specialPackageId: pkg._id, // Tell backend which package to cancel
                carrierId: storedUser?._id,
            });

            if (res.data.success) {
                alert(res.data.message);
                // Update parent state so the green active badge turns red immediately
                setActivePurchase((prev) => ({ ...prev, autoPayment: false }));
            }
        } catch (err) {
            console.error('Cancel sub err:', err);
            alert('Failed to cancel autopay');
        }
    };

    return (
        <div className='mt-6 w-full max-w-md rounded-2xl bg-white shadow-lg p-4 space-y-4 mb-8'>
            <h2 className='text-xl font-semibold text-gray-800 border-b pb-2'>Your Active Special Driver Package</h2>

            <div className='grid grid-cols-2 gap-y-3 text-gray-700'>
                <span className='font-medium'>Name:</span>
                <span>{pkg.name}</span>

                <span className='font-medium'>Price:</span>
                <span>${activePurchase.pricePaid}</span>

                <span className='font-medium'>Duration:</span>
                <span>{pkg.durationDays} Days</span>

                <span className='font-medium'>Access:</span>
                <span>{activePurchase.accessDetails} Logins</span>

                <span className='font-medium'>Code:</span>
                <span>{pkg.code}</span>

                <span className='font-medium'>Valid Until:</span>
                <span className='text-green-600 font-semibold'>
                    {new Date(activePurchase.endDate).toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                    })}
                </span>
            </div>

            <div
                className={`mt-4 rounded-lg px-4 py-2 text-center font-medium ${
                    activePurchase.autoPayment
                        ? 'bg-green-100 text-green-700 border border-green-300'
                        : 'bg-red-100 text-red-700 border border-red-300'
                }`}
            >
                {activePurchase.autoPayment ? '✔ Auto-payment is active' : '✖ Auto-payment is disabled'}
            </div>

            {/* Cancel Autopay Warning & Button */}
            {activePurchase.autoPayment && (
                <div className='w-full rounded-md bg-slate-100 p-4 space-y-3'>
                    <div className='bg-blue-50 border border-blue-200 rounded p-3 mb-2'>
                        <p className='text-sm text-blue-800'>
                            ℹ️ <strong>Note:</strong> Canceling autopay will stop future renewals, but you'll keep full
                            access until{' '}
                            <strong>
                                {new Date(activePurchase.endDate).toLocaleDateString('en-US', {
                                    month: 'long',
                                    day: 'numeric',
                                    year: 'numeric',
                                })}
                            </strong>
                        </p>
                    </div>

                    <button
                        onClick={handleCancelAutopay}
                        className='w-full bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition'
                    >
                        Cancel Autopay
                    </button>
                </div>
            )}
        </div>
    );
};

export default ActiveSpecialPackageCard;
